function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowTriangleWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 312 320",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M144.16 35.355c-23.31 40.604-90.202 156.56-134.23 233.98-3.383 5.95 3.442 17.99 8.947 17.99 53.583-.01 219.25-.07 275.62-.12 6.25 0 11.68-13.15 8.39-18.94-36.26-63.93-103.14-179.32-133.51-232.69-.65-1.131-6.98-6.238-12.21-6.177-5.34.061-11.9 4.017-13.01 5.952z",
    style: {
      fillRule: "evenodd",
      fill: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.11 61.299c-25.38 43.631-81.062 140.52-115.15 198.79-1.349 2.3 1.137 7.3 3.811 7.27 41.745-.41 184.06.24 228.05.17 2.44 0 4.85-5.15 3.64-7.27-28.12-49-90.41-157.97-114.11-198.79-.94-1.616-5.3-1.788-6.24-.171z",
    style: {
      fillRule: "evenodd",
      fill: "#ff0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.44 98.182c-3.7-.068-9.24 1.172-13.03 4.388-3.91 3.31-5.47 5.8-5.5 8.95-.2 25.94 6.15 87.25 6.15 87.25s2.34 9.63 11.69 9.2c8.91-.43 11.39-7.98 11.39-7.98.08 0 6.44-62.62 6.1-88.47-.04-3.1-1.22-4.94-5.07-8.46-3.39-3.097-8.35-4.816-11.73-4.878z",
    style: {
      fillRule: "evenodd",
      fill: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.64 236.28a14.459 12.035 0 1 1-28.92 0 14.459 12.035 0 1 1 28.92 0z",
    style: {
      fillRule: "evenodd",
      fill: "#000"
    },
    transform: "matrix(1.018 0 0 1 -2.928 -.346)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowTriangleWarning);
export default __webpack_public_path__ + "static/media/YellowTriangleWarning.9b29196bee2cf0be2029a6e29c4d98dc.svg";
export { ForwardRef as ReactComponent };